import React from 'react';
import ProgramMegaMenuLinks from './ProgramMegaMenuLinks';
import { closeHeaderMenus } from '../utils/headerMenus';
import { useTranslation } from 'react-i18next';
import './ProgramSubNav.css';

const ProgramSubNav = ({ slug, title, subNavItems, program }) => {
  const { t } = useTranslation();
  return (
    <nav className="program-subnav" aria-label={t('public.common.sections')}>
      <ProgramMegaMenuLinks
        slug={slug}
        title={title}
        variant="subnav"
        subNavItems={subNavItems}
        program={program}
        onNavigate={closeHeaderMenus}
      />
    </nav>
  );
};

export default ProgramSubNav;
